export default __webpack_public_path__ + "static/media/squash.2274679c.jpg";